import _toConsumableArray from "C:\\Users\\Samuele\\source\\frontend\\node_modules\\@babel\\runtime\\helpers\\esm\\toConsumableArray.js";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import _extends from "@babel/runtime/helpers/extends";
var _excluded = ["prefixCls", "className", "source", "style", "onScroll", "onMouseOver", "warpperElement"];
import React, { useImperativeHandle } from 'react';
import ReactMarkdown from 'react-markdown';
import gfm from 'remark-gfm';
import slug from 'rehype-slug';
import headings from 'rehype-autolink-headings';
import rehypeRaw from 'rehype-raw';
import rehypeAttrs from 'rehype-attr'; // @ts-ignore

import rehypePrism from '@mapbox/rehype-prism';
import rehypeRewrite from 'rehype-rewrite';
import { octiconLink } from './nodes/octiconLink';
import { copyElement } from './nodes/copy';
import "./styles/markdown.css";
import "./styles/markdowncolor.css";
import { jsx as _jsx } from "react/jsx-runtime";

var rehypeRewriteHandle = function rehypeRewriteHandle(node, index, parent) {
  if (node.type === 'element' && parent && parent.type === 'root' && /h(1|2|3|4|5|6)/.test(node.tagName)) {
    var child = node.children && node.children[0];

    if (child && child.properties && child.properties.ariaHidden === 'true') {
      child.properties = _extends({
        class: 'anchor'
      }, child.properties);
      child.children = [octiconLink];
    }
  }

  if (node.type === 'element' && node.tagName === 'pre') {
    var code = getCodeStr(node.children);
    node.children.push(copyElement(code));
  }
};

var getCodeStr = function getCodeStr(data, code) {
  if (data === void 0) {
    data = [];
  }

  if (code === void 0) {
    code = '';
  }

  data.forEach(function (node) {
    if (node.type === 'text') {
      code += node.value;
    } else if (node.type === 'element' && node.children && Array.isArray(node.children)) {
      code += getCodeStr(node.children);
    }
  });
  return code;
};

export default /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _props$prefixCls = props.prefixCls,
      prefixCls = _props$prefixCls === void 0 ? 'wmde-markdown wmde-markdown-color' : _props$prefixCls,
      className = props.className,
      source = props.source,
      style = props.style,
      onScroll = props.onScroll,
      onMouseOver = props.onMouseOver,
      _props$warpperElement = props.warpperElement,
      warpperElement = _props$warpperElement === void 0 ? {} : _props$warpperElement,
      other = _objectWithoutPropertiesLoose(props, _excluded);

  var mdp = /*#__PURE__*/React.createRef();
  useImperativeHandle(ref, function () {
    return _extends({}, props, {
      mdp: mdp
    });
  }, [mdp, props]);
  var cls = (prefixCls || '') + " " + (className || '');
  return /*#__PURE__*/_jsx("div", _extends({
    ref: mdp,
    onScroll: onScroll,
    onMouseOver: onMouseOver
  }, warpperElement, {
    className: cls,
    style: style,
    children: /*#__PURE__*/_jsx(ReactMarkdown, _extends({}, other, {
      rehypePlugins: [[rehypePrism, {
        ignoreMissing: true
      }], rehypeRaw, slug, headings, [rehypeRewrite, {
        rewrite: rehypeRewriteHandle
      }], [rehypeAttrs, {
        properties: 'attr'
      }]].concat(_toConsumableArray(other.rehypePlugins || [])),
      remarkPlugins: [].concat(_toConsumableArray(other.remarkPlugins || []), [gfm]),
      children: source || ''
    }))
  }));
});